//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';

//  ----------------------------------------------------------------------------
//  Actions
//  ----------------------------------------------------------------------------

//  -- Create Phrases ----------------
export const createPhrases = () => ({ type: ActionTypes.phrases.createPhrases });
export const createPhrasesFail = (returnedPayload) => ({ type: ActionTypes.phrases.createPhrasesFail, payload: returnedPayload });
export const createPhrasesSuccess = (returnedPayload) => ({ type: ActionTypes.phrases.createPhrasesSuccess, payload: returnedPayload });
export const updatePhrasesSuccess = (returnedPayload) => ({ type: ActionTypes.phrases.updatePhrasesSuccess, payload: returnedPayload });

//  -- List Phrases ----------------
export const listPhrases = () => ({ type: ActionTypes.phrases.listPhrases });
export const listPhrasesFail = (returnedPayload) => ({ type: ActionTypes.phrases.listPhrasesFail, payload: returnedPayload });
export const listPhrasesSuccess = (returnedPayload) => ({ type: ActionTypes.phrases.listPhrasesSuccess, payload: returnedPayload });

// Delete Phrases
export const deletePhrases = () => ({ type: ActionTypes.phrases.deletePhrases });
export const deletePhrasesSuccess = (returnedPayload) => ({ type: ActionTypes.phrases.deletePhrasesSuccess, payload: returnedPayload });
